import styled, { css } from 'styled-components'

import NavMenu from '../NavMenu'
import A from '../A'
import NavMegaMenu from '../NavMegaMenu'
import { mq, sizes } from '../../theme'
import NavMobileMenu from '../NavMobileMenu'
import HeaderSearch from '../HeaderSearch'
import ActionButton from '../ActionButton'
import { ActionIcon, Button } from '../ActionButton/styled'

type ContainerProps = {
  backgroundColor?: string
  isAbridged?: boolean
  isDesktopMenuOpen?: boolean
  ref?: any
}

export const PlaceHolder = styled.div<ContainerProps>`
  @media ${mq(sizes.desktop)} {
    height: 11rem;
  }
  @media print {
    height: 0;
  }
`
export const HeaderContainer = styled.header<ContainerProps>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: ${({ theme }) => theme.zIndexes.header};
  margin-bottom: -2rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border-radius: 0 0 3.5rem 3.5rem;
  overflow: hidden;
  background-color: ${({ backgroundColor, theme }) =>
    backgroundColor ?? theme.colors.pureWhite ?? 'white'};
  box-shadow: 0.2rem 0.2rem 2.4rem 0 rgba(0, 0, 0, 0.13);
  @media ${mq(sizes.desktop)} {
    overflow: hidden visible;
    margin-bottom: -6rem;
    position: fixed;
    top: -12rem;
    left: 0;
    right: 0;
    padding-top: 1.5rem;
    padding-bottom: 0;
    border-radius: ${({ isDesktopMenuOpen }) =>
      isDesktopMenuOpen === false ? '0 0 6rem 6rem' : '0'};
    box-shadow: ${({ isDesktopMenuOpen }) =>
      isDesktopMenuOpen === false
        ? '0.2rem 0.2rem 2.4rem 0 rgba(0, 0, 0, 0.13)'
        : 'none'};
    transition: border-radius 150ms;
  }
  @media print {
    position: relative;
    top: 0;
    left: 0;
    right: 0;
    margin: 0;
  }
`
export const HeaderWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding-left: 2rem;
  padding-right: 2rem;
  margin-left: auto;
  margin-right: auto;
  @media ${mq(sizes.desktop)} {
    flex-flow: column nowrap;
    justify-content: flex-start;
    align-items: stretch;
    padding-left: 0;
    padding-right: 0;
    & > * {
      position: relative;
    }
  }
`
//
export const Logos = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  & > * {
    position: relative;
    flex: 0 1 auto;
  }
  & > *:not(:first-child) {
    margin-left: 1.5rem;
  }
  @media ${mq(0, sizes.desktop - 1)} {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }
  @media ${mq(sizes.desktop)} {
    padding-left: 3rem;
    padding-right: 3rem;
    max-width: 128rem;
    width: 100%;
    margin: auto;
    & > *:not(:first-child) {
      margin-left: 3rem;
    }
  }
`
export const Main = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  min-height: 6rem;
  & > * {
    margin-left: 2.5rem;
  }
  @media ${mq(sizes.tablet)} {
    height: 8.4rem;
  }
  @media ${mq(sizes.desktop)} {
    justify-content: space-between;
    max-width: ${({ theme }) => `${theme.sizes.mangerBougerDesktop}px`};
    width: 100%;
    margin: auto;
    padding: 0 3rem;
    &:not(:first-child) {
      margin-top: 1.8rem;
      &::before {
        content: '';
        position: absolute;
        top: -2px;
        left: 50%;
        width: 102vw;
        height: 1px;
        transform: translateX(-50%);
        background-color: ${({ theme }) => theme.colors.greyf0 ?? 'lightgrey'};
      }
    }
    & > * {
      margin-left: 0;
    }
  }

  @media print {
    height: 6rem;
  }
`
export const MainLogo = styled.div`
  @media ${mq(0, sizes.desktop - 1)} {
    margin-left: auto;
    margin-right: auto;
    padding-left: 6rem; // width of the burger + margin
  }
`

export const Logo = styled(A)<{ width?: any }>`
  display: block;
  /* max-width: ${({ width }) => `calc(${width / 10}rem / 2)` ?? 'none'}; */
  width: 5rem;
  height: 5rem;
  & + & {
    width: 11.5rem;
  }
  ${MainLogo} & {
    width: 17rem;
    height: 2.8rem;
  }
`
//
export const Nav = styled.div`
  @media ${mq(sizes.desktop)} {
    align-self: stretch;
    display: flex;
    justify-content: flex-end;
    list-style: none outside;
    min-width: 70rem;
    position: relative;
  }
`
export const Burger = styled.div`
  display: block;
  @media ${mq(sizes.desktop)} {
    display: none;
  }
  @media print {
    display: none;
  }
`

export const BurgerButton = styled(ActionButton)`
  ${Button} {
    height: 3.5rem;
    width: 3.5rem;
    border-radius: 50%;
    padding: 0;
  }
  ${ActionIcon} {
    width: 1.5rem;
    height: 1.5rem;
  }
`
//
export const Icons = styled.ul`
  display: none;
  @media ${mq(sizes.desktop)} {
    align-self: center;
    display: flex;
    justify-content: row nowrap;
    list-style: none outside;
    & li:not(:first-child),
    & ul:not(:first-child) {
      margin-left: 0.7rem;
    }
    & button,
    a {
      padding: 0;
      & span {
        width: 2rem;
        height: 2rem;
        & svg {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
`
export const Search = styled.li``
export const Account = styled.li``
export const Socials = styled.ul`
  display: flex;
  justify-content: row nowrap;
  list-style: none outside;
`
export const Menu = styled(NavMenu)`
  position: absolute;
  opacity: 0;
  pointer-events: none;
  z-index: -1;
  @media ${mq(sizes.desktop)} {
    position: relative;
    opacity: 1;
    pointer-events: all;
    z-index: auto;
  }
`
export const Filler = styled.div`
  height: 4rem;
  @media ${mq(sizes.tablet)} {
    height: 8.8rem;
  }
  @media ${mq(sizes.desktop)} {
    height: 0;
  }
  @media print {
    height: 0;
  }
`
//
type NavMegaMenuProps = {
  isOpen?: boolean
  isAbridged?: boolean
  ref?: any
}
export const MegaMenu = styled(NavMegaMenu)<NavMegaMenuProps>`
  display: none;
  @media ${mq(sizes.desktop)} {
    position: fixed;
    z-index: ${({ theme }) => theme.zIndexes.header - 1};
    left: 0;
    right: 0;
    display: block;
    opacity: 0;
    transition: opacity 200ms ease-in-out;
    pointer-events: none;
    // open state
    ${({ isOpen }) =>
      isOpen === true &&
      css`
        opacity: 1;
        box-shadow: 0.2rem 0.2rem 2.4rem 0 rgba(0, 0, 0, 0.13);
        transition: opacity 200ms linear 0ms;
        pointer-events: all;
      `}
  }
`
//
export const MobileModal = styled.div<{ isOpen?: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  ${({ isOpen }) =>
    isOpen === false &&
    css`
      opacity: 0;
      pointer-events: none;
    `}
`
export const MobileClose = styled.div``
export const MobileSearch = styled.div``
export const MobileMenu = styled(NavMobileMenu)``
export const SearchInput = styled(HeaderSearch)<{ visible: boolean }>`
  position: absolute;
  inset: 0 0 0 0;
  pointer-events: none;
  opacity: 0;
  transition: opacity 150ms ease-out, transform 150ms ease-out;
  transform: scale(0.5);
  ${({ visible }) =>
    visible &&
    css`
      pointer-events: auto;
      opacity: 1;
      transform: none;
    `}
`
